/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessItemResponse } from '../../models/process-item-response';

export interface GetProcessItems1$Params {
  processId: string;
}

export function getProcessItems1(http: HttpClient, rootUrl: string, params: GetProcessItems1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessItemResponse>>> {
  const rb = new RequestBuilder(rootUrl, getProcessItems1.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProcessItemResponse>>;
    })
  );
}

getProcessItems1.PATH = '/process/{processId}/items/all';
